import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const JUNE_2026_CAMPAIGN_END_DATE = d(2026, 6, 30, 23, 59);
